'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _icon = require('../icon');

var _icon2 = _interopRequireDefault(_icon);

var _datepickerLocal = require('./datepicker.local.css');

var _datepickerLocal2 = _interopRequireDefault(_datepickerLocal);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var Chevron = function Chevron(_ref) {
  var disabled = _ref.disabled,
      className = _ref.className,
      direction = _ref.direction,
      handleClick = _ref.handleClick;
  return _react2.default.createElement('div', {
    className: (0, _classnames2.default)(_datepickerLocal2.default.chevron, className || _datepickerLocal2.default.years)
  }, _react2.default.createElement('button', {
    className: (0, _classnames2.default)(_datepickerLocal2.default.button, !className && _datepickerLocal2.default.year),
    disabled: disabled,
    onClick: handleClick
  }, _react2.default.createElement(_icon2.default, {
    icon: 'selection',
    rotate: direction === 'up' ? 0 : 180,
    color: 'currentColor'
  })));
};

Chevron.propTypes = {
  direction: _propTypes2.default.oneOf(['up', 'down']),
  className: _propTypes2.default.string,
  disabled: _propTypes2.default.bool,
  handleClick: _propTypes2.default.func
};
exports.default = Chevron;